import { Magic } from "magic-sdk";
import { OAuthExtension } from "@magic-ext/oauth";
export const annoMagicKey = process.env.NEXT_PUBLIC_MAGIC_KEY_ANNO || "";
export const createAnnoMagic = () => {
  return new Magic(annoMagicKey, {
    extensions: [new OAuthExtension()]
  });
};
